import React, { useState, useEffect } from "react";
import { MsalAuthenticationTemplate, useMsal } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { loginRequest } from "../authConfig.js";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
// Sample app imports
import CustomerGeneralDetail from "../components/Customer/CustomerGeneralDetail";
import VendorRegisterDetail from "../components/Customer/VendorRegisterDetail";
import AgentRegisterDetail from "../components/Customer/AgentRegisterDetail";
import { Loading } from "../components/Loading";
import { ErrorComponent } from "../components/ErrorComponent";
import { api_path } from "../shared";
import { useSearchParams } from "react-router-dom";

export function CustomerRegisterDetail() {
  const authRequest = {
    ...loginRequest,
  };

  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");
  const getUserID = JSON.parse(localStorage.getItem("USER_ID"));
  const getUserRole = JSON.parse(localStorage.getItem("USER_ROLE_ID"));
  const getUserEMail = JSON.parse(localStorage.getItem("USER_EMAIL"));
  const getEmpCode = JSON.parse(localStorage.getItem("USER_EMPCODE"));
  const isType = (val, num, name) => val == num || val === name;
  useEffect(() => {
    var data = {
      ROLE_ID: getUserRole,
      USER_EMAIL: getUserEMail,
      MENU_URL: window.location.pathname,
    };
    fetch(api_path + "/GET_AUTHEN_URL.php", {
      method: "POST",
      headers: {
        Accept: "application/form-data",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result["status"] == "200") {
          if (result["success"] == "0") {
            window.location = "/s-crm/Home?status=denined";
          }
        }
      });
  }, []);
  return (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      authenticationRequest={authRequest}
      errorComponent={ErrorComponent}
      loadingComponent={Loading}
    >
      <Container maxWidth="md" className="BorderBox">
        <Grid container spacing={2}>
          <Grid container spacing={2}>
            <br />
          </Grid>
          {isType(type, "1", "CUSTOMER") && <CustomerGeneralDetail CustomerID={type} UserID={getUserID} />}
          {isType(type, "2", "AGENT") && <AgentRegisterDetail CustomerID={type} UserID={getUserID} />}
          {isType(type, "3", "VENDOR") && <VendorRegisterDetail CustomerID={type} UserID={getUserID} />}
        </Grid>
      </Container>
    </MsalAuthenticationTemplate>
  );
}
